export interface courseResponse {
    "hasSeenGettingStarted": boolean;
    "freeTrialMenu": boolean;
    "freeTrial": boolean;
    "userName": string;
    "userID": string;
    "sectionList": CourseSection[];
}

export interface courseSection {
    name: string;
    courseList: Courses[];
}

export interface courses {
    itemId: number;
    itemName: string;
    itemLink: string;
    itemAccess: boolean;
    sequence: number;
    badgeLabel: string;
    separatorText: string;
    separatorRequired: boolean;
    badgeRequired: boolean;
}

export class Course implements courses{
    itemId: number;
    itemName: string;
    itemLink: string;
    itemAccess: boolean;
    sequence: number;
    badgeLabel: string;
    separatorText: string;
    separatorRequired: boolean;
    badgeRequired: boolean;
    constructor({
        itemId,
    itemName,
    itemLink,
    itemAccess,
    sequence,
    badgeLabel,
    separatorText,
    separatorRequired,
    badgeRequired
    }:any){
        this.itemId = itemId;
        this.itemName = itemName;
        this.itemLink = itemLink;
        this.itemAccess = itemAccess;
        this.sequence = sequence;
        this.badgeLabel = badgeLabel;
        this.separatorText = separatorText;
        this.separatorRequired = separatorRequired;
        this.badgeRequired = badgeRequired;  
    }
}

export type CourseResponse = courseResponse;
export type CourseSection = courseSection;
export type Courses = courses;